/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-10-27 16:11:14
 */
import React, { ReactElement } from 'react'
import { useContactUS } from './useContactUS'

interface IContactUS {
  style?: React.CSSProperties
  children: ReactElement
  fromPage: string
  artificial?: boolean
  accessId?: string
  track?: () => void
}

const ContactUS: React.FC<IContactUS> = ({
  style,
  children,
  fromPage,
  artificial,
  accessId,
  track
}) => {
  const openContact = useContactUS({ fromPage, artificial, accessId, track })

  return (
    <div onClick={openContact} style={{ ...style, cursor: 'pointer' }}>
      {children}
    </div>
  )
}

export default ContactUS
